import { render } from "./TelehealthHeader.vue?vue&type=template&id=7d59a050&scoped=true&ts=true"
import script from "./TelehealthHeader.vue?vue&type=script&lang=ts"
export * from "./TelehealthHeader.vue?vue&type=script&lang=ts"

import "./TelehealthHeader.vue?vue&type=style&index=0&id=7d59a050&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d59a050"]])

export default __exports__